module.exports = __webpack_public_path__ + "media/images/lp_v6_03-8a64ec5dc32349f0755790a6ad01de77.webp";